export default function PHP_array_change_key_case() {
  return (
    <div>
      <h1>PHP_array_change_key_case</h1>
    </div>
  );
}
